// #612: Mehrere Dateien auf einmal in den Papierkorb (Drive-Papierkorb, dokumente → „Archiviert“) und zurück.
// Gelöschte Dateien verlieren ihre Portal-Freigaben (#607), damit im Portal nichts Gelöschtes stehen bleibt;
// „Rückgängig“ holt die Dateien zurück, die Freigaben aber nicht.
import { stelleWiederHer, verschiebeInPapierkorb } from './aktenschrankApi';
import { entziehe, meldeFreigabenGeaendert } from './freigaben';
import { meldeDokumenteGeaendert } from './useDokumenteKopf';

export interface PapierkorbEintrag { driveId: string; name: string; dokumentId?: string | null }

export interface PapierkorbErgebnis { ok: PapierkorbEintrag[]; fehler: { e: PapierkorbEintrag; meldung: string }[] }

export async function inPapierkorb(eintraege: readonly PapierkorbEintrag[]): Promise<PapierkorbErgebnis> {
  const r: PapierkorbErgebnis = { ok: [], fehler: [] };
  for (const e of eintraege) {
    try { await verschiebeInPapierkorb(e.driveId); r.ok.push(e); }
    catch (err) { r.fehler.push({ e, meldung: err instanceof Error ? err.message : 'fehlgeschlagen' }); }
  }
  const dokIds = r.ok.map(e => e.dokumentId).filter((x): x is string => !!x);
  if (dokIds.length && !(await entziehe(dokIds, null))) meldeFreigabenGeaendert();
  meldeDokumenteGeaendert();
  return r;
}

export async function ausPapierkorb(eintraege: readonly PapierkorbEintrag[]): Promise<number> {
  let n = 0;
  for (const e of eintraege) { try { await stelleWiederHer(e.driveId); n++; } catch { /* einzeln weiter */ } }
  meldeDokumenteGeaendert();
  return n;
}

/** Meldung nach dem Löschen, z. B. „3 Dateien in den Papierkorb verschoben“ (+ Fehler). */
export function papierkorbText(r: PapierkorbErgebnis): string {
  const n = r.ok.length;
  const teil = n === 1 ? `„${r.ok[0]!.name}“ in den Papierkorb verschoben` : `${n} Dateien in den Papierkorb verschoben`;
  if (!r.fehler.length) return teil;
  return `${n ? `${teil} – ` : ''}${r.fehler.length} nicht gelöscht: ${r.fehler[0]!.meldung}`;
}
